import React from "react";
import { Link } from "react-router-dom";
import { MessageCircleMore } from "lucide-react";
import Container from "../components/Container";
import Breadcrumb from "../components/Breadcrumb";
import { cls } from "../utils/helpers";
import { WHATSAPP_NUM } from "../utils/constants";

function openWhatsApp(preset) {
  const num = WHATSAPP_NUM.replace(/\D/g, "");
  const text = encodeURIComponent(
    preset ||
      "Bonjour, je souhaite échanger au sujet de vos prestations / software."
  );
  window.open(`https://wa.me/${num}?text=${text}`, "_blank");
}

export default function SoftwarePage({ p, t }) {
  const modules = [
    {
      id: "soft-planification",
      title: t("soft.plan.title"),
      bullets: [t("soft.plan.b1"), t("soft.plan.b2"), t("soft.plan.b3")],
      soon: true,
    },
    {
      id: "soft-collaboration",
      title: t("soft.collab.title"),
      bullets: [t("soft.plan.b2"), t("soft.log.b2"), t("soft.qual.b3")],
      soon: true,
    },
    {
      id: "soft-logistique",
      title: t("soft.log.title"),
      bullets: [t("soft.log.b1"), t("soft.log.b2"), t("soft.log.b3")],
    },
    {
      id: "soft-qualite",
      title: t("soft.qual.title"),
      bullets: [t("soft.qual.b1"), t("soft.qual.b2"), t("soft.qual.b3")],
      soon: true,
    },
  ];

  return (
    <>
      <Container>
        <Breadcrumb
          items={[{ label: t("crumb.home"), href: "/" }, { label: t("nav.software") }]}
          p={p}
        />
      </Container>

      <section className={p.hero}>
        <Container>
          <div className="py-12">
            <h1 className={cls("text-3xl font-extrabold", p.cardTitle)}>
              {t("soft.title")}
            </h1>
            <p className={cls("mt-2 max-w-3xl", p.paragraph)}>
              {t("soft.subtitle")}
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <a href="#soft-logistique" className={p.chip}>
                {t("soft.log.title")}
              </a>
              <a href="#soft-planification" className={p.chip}>
                {t("soft.plan.title")}
              </a>
              <a href="#soft-collaboration" className={p.chip}>
                {t("soft.collab.title")}
              </a>
              <a href="#soft-qualite" className={p.chip}>
                {t("soft.qual.title")}
              </a>
            </div>
          </div>
        </Container>
      </section>

      <section className="py-10">
        <Container>
          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
            {modules.map((m) => (
              <div
                key={m.id}
                id={m.id}
                className={cls(
                  "relative rounded-2xl border p-6 shadow-sm",
                  p.card
                )}
              >
                {m.id === "soft-planification" && (
                  <span id="soft-par" className="sr-only" aria-hidden="true" />
                )}
                {m.soon && (
                  <span className="absolute top-3 right-3 rounded-full px-3 py-1 text-xs font-bold bg-amber-500 text-white shadow">
                    Bientôt disponible
                  </span>
                )}
                <h2 className={cls("text-lg font-semibold", p.cardTitle)}>
                  {m.title}
                </h2>
                <ul className="mt-3 text-sm space-y-1">
                  {m.bullets.map((b, i) => (
                    <li key={i} className="flex gap-2 items-start">
                      <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-current" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-4 flex gap-2">
                  {m.soon ? (
                    <button
                      disabled
                      className={cls(
                        p.ctaSecondary,
                        "opacity-70 cursor-not-allowed"
                      )}
                    >
                      {t("btn.soon")}
                    </button>
                  ) : (
                    <Link to="/pricing" className={p.ctaPrimary}>
                      {t("nav.pricing")}
                    </Link>
                  )}
                  <button
                    onClick={() =>
                      openWhatsApp(`Bonjour, je souhaite une démo: ${m.title}`)
                    }
                    className={cls(p.ctaSecondary, "inline-flex items-center gap-2")}
                  >
                    <MessageCircleMore size={16} /> WhatsApp
                  </button>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
}
